import { useMemo, useState } from 'react'
import { FormApi, FormConfig } from '@workwave-tidal/core/form'
import { ModalContent } from '@/components/Modal'
import { Stack } from '@mui/material'
import { useConfigureController } from '../../hooks/useController'
import { useLocationEditorMap } from './hooks/useLocationEditorMap'
import { useOnSubmit } from './hooks/useOnSubmit'
import { AdjustAddressFormValues } from './types'
import { Data } from './components/Data'
import { Header } from './components/Header'
import { Map } from './components/Map'
import { Footer } from './components/Footer'
import { form } from './formState'

type Props = {
  label: string
  pinId:
    | 'depotFormPin'
    | 'placeFormPin'
    | 'geofenceFormPin'
    | 'orderForm_pickup'
    | 'orderForm_service'
    | 'orderForm_delivery'
  pinType: uui.domain.ui.map.LocationPinType
  onChange: (payload: uui.domain.client.Location) => void
  location: uui.domain.client.Location
}

export function Content(props: Props) {
  const { location, pinType, pinId, onChange, label } = props

  const { ready } = useConfigureController(location.latLng, pinId)
  const [formApi, setFormApi] = useState<FormApi<AdjustAddressFormValues> | null>(null)

  // Initialize the map
  const map = useLocationEditorMap(pinId, pinType, formApi)

  const onSubmit = useOnSubmit(pinId, onChange, label, formApi)

  const config = useMemo<FormConfig<AdjustAddressFormValues>>(
    () => ({
      id: 'adjustAddressForm',
      initialValues: {
        newLocation: { ...location },
        originalLocation: { ...location },
        keepLocationAddress: false,
      },
    }),
    [location],
  )

  if (!ready) return null

  return (
    <ModalContent maxWidth={800} header={<Header pinId={pinId} />}>
      <form.Form
        onFormApi={setFormApi}
        onInitialize={() => config}
        disableScroll
        header={null}
        footer={<Footer map={map} pinId={pinId} onSubmit={onSubmit} />}
      >
        <Stack width={586}>
          <Map map={map} pinId={pinId} />
          <Data pinId={pinId} map={map} />
        </Stack>
      </form.Form>
    </ModalContent>
  )
}
